import React from 'react';
import { useAppTheme } from '../../hooks/useAppTheme';
import './ResponsiveBackground.css';

interface ResponsiveBackgroundProps {
  className?: string;
  children?: React.ReactNode;
  overlay?: boolean; // Option pour ajouter un overlay semi-transparent
}

/**
 * Composant qui affiche un fond d'écran adaptatif selon la taille de l'appareil
 * Utilise des media queries CSS pour charger l'image appropriée selon la taille d'écran
 */
export const ResponsiveBackground: React.FC<ResponsiveBackgroundProps> = ({ 
  className = '',
  children,
  overlay = false,
}) => {
  const { theme } = useAppTheme();
  
  return (
    <div className="background-container">
      <div className={`responsive-background ${overlay ? 'with-overlay' : ''} ${className} theme-${theme}`} />
      <div className="content-wrapper">
        {children}
      </div>
    </div>
  );
};

export default ResponsiveBackground;